import { render, staticRenderFns } from "./CardMini.vue?vue&type=template&id=6c9a47fc&scoped=true"
import script from "./CardMini.vue?vue&type=script&lang=js"
export * from "./CardMini.vue?vue&type=script&lang=js"
import style0 from "./CardMini.vue?vue&type=style&index=0&id=6c9a47fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a47fc",
  null
  
)

export default component.exports